import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './FiveWhysHome.css';

function FiveWhysHome() {
  return (
    <div className="min-h-screen bg-black py-4">
      
      <div className="min-h-[80vh] lg:min-h-[92vh] px-2 mx-auto">
        <div className="flex justify-start mb-2 border-b border-blue-400">
            <h2 className="text-xl lg:text-2xl font-bold text-yellow-200 text-center mb-4 px-4">❓ 5 Whys Analysis</h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-2 py-4 place-items-center">
          <CardLink to="/think5whys-db-list" emoji="💾" text="Examples for Everyone" delay={0} />
          <CardLink to="/think5whys-extension-example" emoji="⚡" text="Extensive Use-Cases" delay={100} />
          <CardLink to="/my-concerns-list" emoji="⚠️" text="My Concerns" delay={200} />
          <CardLink to="/my-objectives-list" emoji="🎯" text="My Objectives" delay={300} />
          <CardLink to="/team-concerns-list" emoji="💼" text="Team's Concerns" delay={400} />
          <CardLink to="/team-objectives-list" emoji="📊" text="Team's Objectives" delay={500} />
          <CardLink to="/think5whys-extension-my" emoji="⚡" text="My Extensive Report" delay={600} />
          <CardLink to="/statistics-analysis" emoji="⬇️" text="Statistics & Analytics" delay={700} />
          <CardLink to="/fishbone-home" emoji="🐟" text="My Fishbones Diagrams" delay={800} />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-2 border-t border-blue-400 py-4 place-items-center">
          <CardLink to="/focusdashboard" emoji="👥" text="FOCUS Dashboard" delay={900} />
          <CardLink to="/healthierdashboard" emoji="✅" text="HEALTHIER Dashboard" delay={1000} />
          <CardLink to="/inspiredashboard" emoji="🏫" text="INSPIRE Dashboard" delay={1100} />
          <CardLink to="/sheetaldashboard" emoji="📋" text="SHEETAL Dashboard" delay={1200} />
          <CardLink to="/vardhinidashboard" emoji="🌾" text="Vardhini Dashboard" delay={1300} />
          <CardLink to="/finwiserdashboard" emoji="💰" text="Finwiser Dashboard" delay={1400} />
        </div>
      </div>
      <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>      
    </div>
  );
}

const CardLink = ({ to, icon, emoji, text, delay }) => (
  <Link
    to={to}
    className="bg-gray-800 w-64 p-2 rounded-lg shadow-lg transition-all duration-300 ease-in-out hover:scale-105 hover:bg-gray-700 hover:shadow-xl flex items-center text-xs text-blue-200 hover:text-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-500 border border-gray-700 group animate-fade-in"
    style={{ animationDelay: `${delay}ms` }}
  >
    <div className="flex items-center mr-3 flex-shrink-0">
      <span className="text-xl mr-2 group-hover:scale-110 transition-transform duration-300">{emoji}</span>
   </div>
    <span className="flex-1 text-left transform translate-y-0 group-hover:translate-y-[-2px] transition-transform duration-300 text-sm lg:text-m break-words">
      {text}
    </span>
  </Link>
);

// CardNoLink Component
const CardNoLink = ({ icon, emoji, text, delay }) => (
  <div 
    className="bg-gray-700 p-3 rounded-lg shadow-lg transition-all duration-300 ease-in-out hover:scale-105 cursor-not-allowed opacity-60 flex items-center text-xs sm:text-sm text-gray-400 border border-gray-600 animate-fade-in"
    style={{ animationDelay: `${delay}ms` }}
  >
    <div className="flex items-center mr-3 flex-shrink-0">
      <span className="text-2xl mr-2">{emoji}</span>
      <FontAwesomeIcon icon={icon} className="text-lg" />
    </div>
    <span className="flex-1 text-left">{text}</span>
  </div>
);

export default FiveWhysHome;